import { Amplify } from 'aws-amplify'

const COGNITO_USER_POOL_ID = import.meta.env.VITE_COGNITO_USER_POOL_ID || ''
const COGNITO_CLIENT_ID = import.meta.env.VITE_COGNITO_CLIENT_ID || ''
const COGNITO_DOMAIN = import.meta.env.VITE_COGNITO_DOMAIN || ''
const APP_URL = import.meta.env.VITE_APP_URL || 'http://localhost:3000'

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: COGNITO_USER_POOL_ID,
      userPoolClientId: COGNITO_CLIENT_ID,
      loginWith: {
        oauth: {
          domain: COGNITO_DOMAIN,
          scopes: ['email', 'profile', 'openid'],
          redirectSignIn: [`${APP_URL}/auth/callback`],
          redirectSignOut: [`${APP_URL}/`],
          responseType: 'code',
          providers: ['Google'],
        },
      },
    },
  },
})
